import React from 'react';
import { ShieldCheck, Check } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-16 px-4 bg-black" data-id="element-92">
      <div className="max-w-3xl mx-auto" data-id="element-93">
        <div className="bg-zinc-900 rounded-3xl border border-green-500/30 overflow-hidden relative" data-id="element-94">
          <div className="absolute top-0 inset-x-0 h-1 bg-gradient-to-r from-green-400 via-green-500 to-green-600" data-id="element-95" />

          <div className="p-8 sm:p-12 text-center" data-id="element-96">
            <div className="inline-flex p-4 rounded-full bg-green-500/10 mb-6" data-id="element-97">
              <ShieldCheck className="w-12 h-12 text-green-500" data-id="element-98" />
            </div>

            <h2 className="text-3xl font-bold text-white mb-2" data-id="element-99">
              Garantía Total de 7 Días
            </h2>
            <p className="text-green-400 font-semibold mb-6" data-id="element-100">
              Tu compra está 100% protegida
            </p>
            <p className="text-zinc-400 mb-4 leading-relaxed" data-id="element-101">
              Si por cualquier motivo sientes que el material no es lo que
              esperabas, te devolvemos el 100% de tu dinero. Sin preguntas, sin
              excusas, sin burocracia.
            </p>
            <p className="text-zinc-300 font-medium mb-8" data-id="element-102">
              El riesgo es cero. Si no te sirve, no pagas. Así de simple.
            </p>

            <div className="flex flex-col sm:flex-row justify-center gap-4 sm:gap-8 text-sm font-medium text-zinc-300" data-id="element-103">
              <div className="flex items-center justify-center gap-2" data-id="element-104">
                <Check className="w-4 h-4 text-green-500" data-id="element-105" />
                Devolución sin preguntas
              </div>
              <div className="flex items-center justify-center gap-2" data-id="element-106">
                <Check className="w-4 h-4 text-green-500" data-id="element-107" />
                Reembolso en 48hs
              </div>
              <div className="flex items-center justify-center gap-2" data-id="element-108">
                <Check className="w-4 h-4 text-green-500" data-id="element-109" />
                Procesado por Hotmart
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}